/**
 * Feature switches for the Campaigns module.
 */

/** Loyalty tiers are not in the live Loyalty module yet; the switch lives with the segment rules. */
export { TIERS_ENABLED } from '../../redux/customers/customerSegmentRules';

/** Draft autosave delay after the last change (UI-02). */
export const AUTOSAVE_DELAY_MS = 1500;

/** CMP-09 — a scheduled send must be at least this far in the future. */
export const MIN_SCHEDULE_LEAD_MINUTES = 15;

/** GRD-01 defaults; settings may only be stricter (GRD-05). */
export const DEFAULT_QUIET_START = '21:00';
export const DEFAULT_QUIET_END = '08:00';
